import { Button } from "@nextui-org/button";
import Link from "next/link";
import { IoChevronForward } from "react-icons/io5";
import ListItemDocument from "@/app/components/ListItemDocument";
import { ChartTitle } from "@/app/components/ChartSection";

export function AuthorDocumentsList({ docs, authorId }) {
  const documentsHref = `/author/${authorId}/documents`;
  const hasDocs = docs && docs.length > 0;

  return (
    <section
      className="mt-5 p-5 text-left shadow-lg"
      aria-label="Publicaciones del autor"
    >
      <ChartTitle
        title="Publicaciones del autor"
        tooltip={
          hasDocs
            ? "Vista previa de publicaciones. El botón lleva al listado completo."
            : "No hay publicaciones en esta vista previa. Puedes abrir el listado completo."
        }
      />
      {hasDocs ? (
        <>
          <ul>
            {docs.map((doc) => (
              <ListItemDocument
                key={doc.id}
                doc={doc}
                path={`/document/${doc.id}`}
              />
            ))}
          </ul>
          <div className="mt-5 flex flex-row-reverse">
            <Button
              as={Link}
              href={documentsHref}
              color="primary"
              variant="solid"
              className="capitalize"
              endContent={<IoChevronForward />}
            >
              Más documentos
            </Button>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-start gap-4">
          <p className="text-sm text-slate-600">
            No hay publicaciones para mostrar en esta vista previa.
          </p>
          <Button
            as={Link}
            href={documentsHref}
            color="primary"
            variant="bordered"
            endContent={<IoChevronForward />}
          >
            Ver documentos
          </Button>
        </div>
      )}
    </section>
  );
}
